import {ChangeDetectorRef, Component, ElementRef, OnInit, Renderer2} from '@angular/core';
import {BaseFieldComponent} from '../../base/base-field/base-field.component';
import {DynamicFormService} from '../../../dynamic-form/dynamic-form.service';
import {EventDispatcherService} from '../../../events/event-dispatcher.service';
import {DividerFieldConfig} from '../divider-field.config';

@Component({
    selector: 'mydocma-field-divider',
    templateUrl: 'divider-field.component.html',
    styleUrls: ['divider-field.component.scss']
})
export class DividerFieldComponent extends BaseFieldComponent<DividerFieldConfig> implements OnInit {
    public readonly staticCssClass = 'mydocma-divider-field';

    constructor(
        public readonly dynamicFormService: DynamicFormService,
        public readonly changeDetectorRef: ChangeDetectorRef,
        public readonly eventDispatcher: EventDispatcherService,
        element: ElementRef,
        renderer: Renderer2
    ) {
        super(dynamicFormService, changeDetectorRef, eventDispatcher,element,renderer);
    }
}
